const formatTimestamp = () => {
  return new Date()
    .toISOString()
    .replace(/[-:.TZ]/g, "")
    .slice(0, 14);
};

const appendSubscriptionEventLog = ({ eventType, validUntil, status, subscriptionId, lastPayment }) => {
  const ts = formatTimestamp();
  const eventLabelMap = {
    "sign-in": "sign-in",
    "sign-up": "sign-in",
    subscription: "subscription",
    unsubscribe: "unsubscribe",
  };
  const label = eventLabelMap[eventType] || "event";
  const payment = lastPayment || "unknown";
  const entry = {
    timestamp: ts,
    type: eventType,
    next_billing_time: validUntil || "unknown",
    status: status || "unknown",
    subID: subscriptionId || "none",
    lastPayment: payment,
    message: `${ts}: PayPal Subscription valid until: ${validUntil || "unknown"}, Subscription status: ${status ||
      "unknown"}. Subscription ID: ${subscriptionId || "none"}. Last payment: ${payment}. ${label} detected.`,
  };
  const list = JSON.parse(localStorage.getItem("subLog")) || [];
  list.push(entry);
  localStorage.setItem("subLog", JSON.stringify(list));
  return entry;
};

export { appendSubscriptionEventLog };
